import MU from '../constants/muConstants';

export const AddToCalendarButtons = (title, startDate, endDate, description, type) => {
  const formatDate = (date) => {
    return `${new Date(date).toISOString().replace(/[-:]/g, '').split('.')[0]}Z`;
  };

  // Format start and end dates
  const startFormatted = startDate && formatDate(startDate);
  const endFormatted = endDate && formatDate(endDate);

  if (type === 'Google') {
    // Generate Google Calendar URL
    const googleCalendarURL = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
      title
    )}&dates=${startFormatted}/${endFormatted}&details=${encodeURIComponent(description)}`;
    return googleCalendarURL;
  }

  if (type === 'Outlook' || type === 'Apple') {
    // Function to download ICS file
    const downloadICS = () => {
      const icsFileContent = `
          BEGIN:VCALENDAR
          VERSION:2.0
          PRODID:MU
          BEGIN:VEVENT
          UID:${new Date().getTime()}
          DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').split('.')[0]}Z
          DTSTART:${startFormatted}
          DTEND:${endFormatted}
          SUMMARY:${title}
          DESCRIPTION:${description}
          BEGIN:VALARM
          TRIGGER:-PT15M
          ACTION:DISPLAY
          END:VALARM
          END:VEVENT
          END:VCALENDAR`;
      const blob = new Blob([icsFileContent], { type: 'text/calendar' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${title}.ics`;
      link.click();
    };
    return downloadICS;
  }
};

export const calendarHeadline = () => MU?.eventCalendar?.calendarHeadline;
export const calendarTitle = () => MU?.eventCalendar?.calendarTitle;
export const calendarDescription = () => MU?.eventCalendar?.calendarDescription;

export const fixtureCalendarHeadline = () => MU?.eventCalendar?.fixtureCalendarHeadline;
export const noteHeadline = () => MU?.eventCalendar?.noteHeadline;
export const noteDescription = () => MU?.eventCalendar?.noteDescription;
export const appleShortAddtoCalendar = () => MU?.eventCalendar?.appleShortAddtoCalendar;
export const googleShortAddtoCalendar = () => MU?.eventCalendar?.googleShortAddtoCalendar;
export const outlookShortAddtoCalendar = () => MU?.eventCalendar?.outlookShortAddtoCalendar;

const getTeamforCal = (team) => {
  const myteam = team && team.toLowerCase();
  switch (myteam) {
    case 'first team':
      return "Men's";
    case 'women team':
      return "Women's";
    case 'academy':
      return "Under-18's";
    case 'reserves':
      return "Under-21's";
    default:
      return '';
  }
};

export const getFixtureTeam = (myTeam) => {
  const eventCalender = MU?.eventCalendar;
  const teamToShow = getTeamforCal(myTeam);
  const fixtureCalendarTitle = eventCalender?.fixtureCalendarTitle;
  if (fixtureCalendarTitle?.includes('{}') && teamToShow) {
    return fixtureCalendarTitle.replace('{}', teamToShow);
  } else if (fixtureCalendarTitle) {
    return fixtureCalendarTitle;
  } else return '';
};

export const getFixtureConfiguration = (myTeam) => {
  const eventCalender = MU?.eventCalendar;
  const fixtureConfiguration =
    eventCalender?.fixtureConfiguration && typeof eventCalender.fixtureConfiguration === 'string'
      ? JSON.parse(eventCalender.fixtureConfiguration)
      : eventCalender.fixtureConfiguration;
  if (myTeam && fixtureConfiguration) {
    return fixtureConfiguration.teams.find(
      (item) => item.levelUnique?.toLowerCase() === myTeam?.toLowerCase()
    );
  }
};
export const descriptionText = () => {
  return 'DescriptionText';
};
